import React from 'react';
import Modal from 'react-modal';
import { FiAlertTriangle } from 'react-icons/fi';

Modal.setAppElement('#root'); // Set the root element for accessibility

const DeleteConfirmModal = ({ isOpen, onRequestClose, onConfirm, itemType }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal-content p-6 max-w-sm mx-auto my-20 bg-white rounded-lg shadow-xl relative"
      overlayClassName="modal-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    >
      <div className="flex flex-col items-center justify-center space-y-4">
        <FiAlertTriangle className="text-red-500" size={48} />
        <h2 className="text-xl font-bold text-gray-800">Confirm Deletion</h2>
        <p className="text-center text-gray-600">
          Are you sure you want to delete this {itemType} This action cannot be undone.
        </p>
      </div>

      <div className="mt-6 flex justify-center space-x-4">
        <button
          onClick={onRequestClose}
          className="bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400 transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
        >
          Delete
        </button>
      </div>
    </Modal>
  );
};

export default DeleteConfirmModal;